import { Routes, Route } from "react-router-dom";
import MyPage from "works/chi/pages/MyPage";
import Tickets from "works/chi/pages/Tickets";
import Quests from "works/chi/pages/Quests";
import HowToUse from "works/chi/pages/HowToUse";
import ConfirmPayPay from "works/chi/pages/ConfirmPayPay";
import CheckPayPayStatus from "works/chi/pages/CheckPayPayStatus";
import PayPayPolling from "works/chi/pages/PayPayPolling";
import ShortenTicket from "works/chi/pages/ShortenTicket";
import MemoryRollback from "works/chi/pages/MemoryRollback";
import QuestClearRequest from "works/chi/pages/QuestClearRequest";
import RequestForm from "works/chi/pages/RequestForm";
import EmailSettings from "default/pages/EmailSettings";
import News from "default/pages/News";

export default function ChiRoutes() {
  return (
    <Routes>
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/quests" element={<Quests />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/confirm-paypay" element={<ConfirmPayPay />} />
      <Route path="/check-paypay" element={<CheckPayPayStatus />} />
      <Route path="/paypay-polling" element={<PayPayPolling />} />
      <Route path="/shorten-ticket" element={<ShortenTicket />} />
      <Route path="/memory-rollback" element={<MemoryRollback />} />
      <Route path="/quest-clear-request" element={<QuestClearRequest />} />
      <Route path="/request-form" element={<RequestForm />} />
      <Route path="/email-settings" element={<EmailSettings />} />
      <Route path="/news" element={<News />} />
    </Routes>
  );
}
